// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nh-1";
export var messageSideRight = "_nh-2";
export var orderLookupBubbleContainer = "_nh-0";
export var submitButton = "_nh-3";